// extracted by mini-css-extract-plugin
module.exports = {"input":"NameInput_input__2Ob4m"};